<ndc-dynamic [ndcDynamicComponent]="componentType" [ndcDynamicInputs]="inputs" [ndcDynamicOutputs]="outputs" (ndcDynamicCreated)="onComponentCreated($event)"></ndc-dynamic>
